import { FormYesNoComponent } from "@portal/components/form/fieldLayouts";
import { useIsCommercialSuretyEnabled } from "@portal/hooks/useIsCommercialSuretyEnabled";
import { useFormContext } from "react-hook-form";

type PaymentAndPerformanceBondsForm = {
	requiresPaymentAndPerformanceBonds?: boolean;
};

type PaymentAndPerformanceBondsFieldProps = {
	compact?: boolean;
	deselectable?: boolean;
};

export const PaymentAndPerformanceBondsField = ({
	compact,
	deselectable,
}: PaymentAndPerformanceBondsFieldProps) => {
	const formMethods = useFormContext<PaymentAndPerformanceBondsForm>();
	const isCommercialSuretyEnabled = useIsCommercialSuretyEnabled();

	if (!isCommercialSuretyEnabled) {
		return null;
	}

	return (
		<FormYesNoComponent
			formMethods={formMethods}
			name="requiresPaymentAndPerformanceBonds"
			label="Does this account need payment & performance bonds?"
			compact={compact}
			deselectable={deselectable}
			testId="requires-p-and-p-bonds"
		/>
	);
};
